var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelIcon = function SvgCancelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.738,
    height: 63.057,
    viewBox: "0 0 77.738 63.057"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a1{fill:#16b6bf;}.b1,.d1{fill:none;}.b1{stroke:#171926;stroke-width:2px;}.c1{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -49.084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.129,103.111H7.9a1.129,1.129,0,1,0,0,2.258H60.129a1.129,1.129,0,1,0,0-2.258Zm0-4.515H7.9a1.129,1.129,0,1,0,0,2.258H60.129a1.129,1.129,0,1,0,0-2.258ZM66.9,83.884a1.129,1.129,0,0,0-1.129,1.129V106.5a3.39,3.39,0,0,1-3.386,3.386H5.644A3.39,3.39,0,0,1,2.258,106.5V70.432a3.39,3.39,0,0,1,3.386-3.386H40.915a1.129,1.129,0,1,0,0-2.258H5.644A5.65,5.65,0,0,0,0,70.432V106.5a5.65,5.65,0,0,0,5.644,5.644H62.386a5.65,5.65,0,0,0,5.644-5.644V85.012A1.129,1.129,0,0,0,66.9,83.884Zm-6.22-33.7a16.381,16.381,0,0,0-15.6,21.372h-7.83a1.129,1.129,0,1,0,0,2.258H46a16.407,16.407,0,0,0,1.355,2.258h-10.1a1.129,1.129,0,1,0,0,2.258H49.3A16.376,16.376,0,1,0,60.682,50.188Zm0,30.5A14.122,14.122,0,1,1,74.8,66.568,14.138,14.138,0,0,1,60.682,80.69Zm-.553,8.875H37.251a1.129,1.129,0,1,0,0,2.258H60.129a1.129,1.129,0,1,0,0-2.258Zm0,4.515H37.251a1.129,1.129,0,1,0,0,2.258H60.129a1.129,1.129,0,1,0,0-2.258Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,34A17,17,0,0,1,10.383,1.336,17,17,0,0,1,23.617,32.664,16.894,16.894,0,0,1,17,34ZM17,7.556a11.333,11.333,0,1,0,8.014,3.319A11.259,11.259,0,0,0,17,7.556Z",
    transform: "translate(43.738 49.084)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(45.869 51.084)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.869 58.086)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b1",
    d: "M-23457-22296l16,16",
    transform: "translate(23456.996 22296.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1",
    d: "M-23457-22280l16-16",
    transform: "translate(23456.996 22296.002)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b1",
    transform: "translate(7 71.084)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c1",
    width: 25,
    height: 25,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d1",
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-88.829,1144.75v-10.916l6.8-4.934,6.837,4.96v10.89Zm7.777-2H-77.1v-7.969l-4.9-3.556-4.91,3.562v7.963h3.95v-2.822h1.913Z",
    transform: "translate(101.51 -1053.239)"
  }))));
};
export default SvgCancelIcon;